export {useDocumentScrollLock as useScrollLock} from '@fitro/overlay-layout'
